<div class="email-contacts-dialog__shell">
  <div class="close-button">
    <button tabIndex="-1" class="" mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <h1 mat-dialog-title>{{ 'contacts' | translate }}</h1>
  <mat-dialog-content
    class="email-contacts-dialog__content mat-mdc-dialog-content mdc-dialog__content mat-container">
    <div class="email-contacts-dialog__toolbar">
      <div class="email-contacts-dialog__filters">
        <mat-form-field class="email-contacts-dialog__search">
          <mat-icon class="absolute bottom-[4px] right-0 text-[22px]"
            >search</mat-icon
          >
          <mat-label>{{ 'search' | translate }}</mat-label>
          <input
            type="text"
            #input
            placeholder="{{ 'searchContacts' | translate }}"
            aria-label="Search contacts"
            matInput
            [formControl]="myControl" />
        </mat-form-field>
        <app-email-search-tag-input
          class="email-contacts-dialog__tags-filter"
          [mailAccountId]="mailAccountId"
          [tagType]="tagType"
          [selectedTags]="selectedTags"
          (tagsChange)="onTagsFilterChange($event)" />
      </div>
    </div>
    <div class="email-contacts-dialog__table-scroll">
      @if (!isError && isLoading && !isLoadingScroll) {
        <div class="overflow-hidden pt-4">
          <div class="flex w-full gap-3">
            <div class="w-[90%]">
              <ngx-skeleton-loader
                [count]="1"
                [theme]="{
                  height: '24px',
                  width: '20%',
                }"></ngx-skeleton-loader>
            </div>
            <div class="w-[10%]">
              <ngx-skeleton-loader
                [count]="1"
                [theme]="{
                  height: '24px',
                  width: '30%',
                }"></ngx-skeleton-loader>
            </div>
          </div>
          <div>
            <ngx-skeleton-loader
              [count]="8"
              [theme]="{
                height: '24px',
                width: '100%',
              }"></ngx-skeleton-loader>
          </div>
        </div>
      }
      @if (!isLoading && isError) {
        <div class="h-full min-h-[200px] w-full">
          <app-something-went-wrong
            [showPicture]="false"
            (retryEmitter)="retryLoad()"></app-something-went-wrong>
        </div>
      }

      @if (!isError && !isLoading) {
        <app-infinity-scroll
          [isErrorScroll]="isErrorScroll"
          [isLoadingScroll]="isLoadingScroll"
          [canNavigateForward]="canNavigateForward"
          [dataLength]="dataSource.data.length"
          (loadData)="onScroll()"
          (refreshData)="refreshData()">
          <div class="table-responsive">
            <table mat-table [dataSource]="dataSource">
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef style="width: 36px">
                  <mat-checkbox
                    (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    color="primary"
                    [indeterminate]="selection.hasValue() && !isAllSelected()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" style="width: 36px">
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)"
                    color="primary">
                  </mat-checkbox>
                </td>
              </ng-container>
              <ng-container matColumnDef="alias">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'alias' | translate }}
                </th>
                <td
                  mat-cell
                  *matCellDef="let contact"
                  (click)="addContact(contact.defaultEmail)">
                  {{ contact.alias }}
                </td>
              </ng-container>
              <ng-container matColumnDef="email">
                <th class="flex-1" mat-header-cell *matHeaderCellDef>
                  {{ 'email' | translate }}
                </th>
                <td
                  class="flex-1"
                  mat-cell
                  style="cursor: pointer"
                  *matCellDef="let contact"
                  (click)="addContact(contact.defaultEmail)">
                  {{ contact?.defaultEmail ?? '' }}
                </td>
              </ng-container>
              <ng-container matColumnDef="label">
                <th mat-header-cell *matHeaderCellDef>
                  {{ 'label' | translate }}
                </th>
                <td mat-cell *matCellDef="let contact">
                  <div
                    class="app-tags tags-main flex flex-wrap items-center gap-x-2 gap-y-1 py-1">
                    @for (tag of contact.tags ?? []; track tag.tag) {
                      <app-tag-component [tag]="tag" />
                    }
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
          </div>
          @if (!dataSource.data.length) {
            <app-no-data></app-no-data>
          }
        </app-infinity-scroll>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="mat-mdc-dialog-actions mdc-dialog__actions">
    <div class="flex w-full justify-end">
      <button
        [disabled]="selection.isEmpty()"
        color="primary"
        mat-raised-button
        (click)="addSelectedContacts()">
        {{ 'select' | translate }}
      </button>
    </div>
  </mat-dialog-actions>
</div>
